import React from 'react';
import usePasswordValidation from '../../hooks/auth/usePasswordValidation';

const RequirementRow = ({ met, children }) => {
  return (
    <div className="flex items-start text-sm mb-1">
      <span className={`mr-2 font-bold ${met ? 'text-green-600' : 'text-gray-500'}`} aria-hidden>
        {met ? '✔' : '✘'}
      </span>
      <span className={`${met ? 'text-green-700' : 'text-gray-700'}`}>{children}</span>
    </div>
  );
};

export default function PasswordRequirements({ value = '', onValidityChange, className = '' }) {
  const {
    hasMinLength,
    hasNumber,
    hasSymbol,
    hasUppercase,
    hasLowercase,
    isValid
  } = usePasswordValidation(value, onValidityChange);

  return (
    <div className={className} aria-live="polite">
      <div>
        <RequirementRow met={hasMinLength}>At least 12 characters</RequirementRow>
        <RequirementRow met={hasNumber}>At least 1 number</RequirementRow>
        <RequirementRow met={hasSymbol}>At least 1 symbol (e.g., !, @, #)</RequirementRow>
        <RequirementRow met={hasUppercase}>At least 1 uppercase letter (A–Z)</RequirementRow>
        <RequirementRow met={hasLowercase}>At least 1 lowercase letter (a–z)</RequirementRow>
      </div>
      <span className="sr-only">Password {isValid ? 'meets' : 'does not meet'} all requirements</span>
    </div>
  );
}


